import { OnboardingPreLogin } from "@/components/OnboardingPreLogin";
import { useOnboardingPreLogin } from "@/hooks/useOnboardingPreLogin";
import { ForgotPassword } from "@/pages/auth/forgot-password";
import { Login } from "@/pages/auth/login";
import MainCadastro from "@/pages/auth/sign-in";
import { Navigate, Route, Routes } from "react-router-dom";

export function AuthRoutes() {
  const { 
    isOnboardingVisible, 
    completeOnboarding, 
    skipOnboarding 
  } = useOnboardingPreLogin();

  if (isOnboardingVisible) {
    return (
      <OnboardingPreLogin 
        onComplete={completeOnboarding}
        onSkip={skipOnboarding}
      />
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/sign-in" element={<MainCadastro />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
} 